import { customColorSchemes } from "./colorSchemes";

export const fileTypeList = [
    { key: "csv", text: "csv", value: "csv" },
    { key: "json", text: "json", value: "json" }
    //{ key: "xml", text: "xml", value: "xml" }
    //{ key: "excel", text: "excel (.xlsx/.xls)", value: "excel" }
];

export const chartNameList = [
    { key: "pie", text: "pie", value: "pie" },
    { key: "bar", text: "bar", value: "bar" }
    // { key: "line", text: "line", value: "line" }
];

export const axisNameList = [
    { key: "x", text: "sort by name", value: "x" },
    { key: "y", text: "sort by value", value: "y" }
];

export const colorSchemeList = [
    { key: "Default", text: "Default", value2: customColorSchemes.Meine, value: "0" },
    { key: "Accent", text: "Accent", value2: customColorSchemes.Accent, value: "1" },
    { key: "Set 1", text: "Set 1", value2: customColorSchemes.Set1, value: "2" },
    { key: "Set 2", text: "Set 2", value2: customColorSchemes.Set2, value: "3" },
    { key: "Set 3", text: "Set 3", value2: customColorSchemes.Set3, value: "4" },
    { key: "Spectral", text: "Spectral", value2: customColorSchemes.Spectral, value: "5" },
    { key: "Paired", text: "Paired", value2: customColorSchemes.Paired, value: "6" },
    { key: "Pastel 1", text: "Pastel 1", value2: customColorSchemes.Pastel1, value: "7" },
    { key: "Pastel 2", text: "Pastel 2", value2: customColorSchemes.Pastel2, value: "8" },
    { key: "Dark", text: "Dark", value2: customColorSchemes.Dark2, value: "9" },
    { key: "Greys", text: "Greys", value2: customColorSchemes.Greys, value: "10" },

    { key: "Blues", text: "Blues", value2: customColorSchemes.Blues, value: "11" },
    { key: "BrBG", text: "BrBG", value2: customColorSchemes.BrBG, value: "12" },
    { key: "BuGn", text: "BuGn", value2: customColorSchemes.BuGn, value: "13" },
    { key: "BuPu", text: "BuPu", value2: customColorSchemes.BuPu, value: "14" },
    { key: "GnBu", text: "GnBu", value2: customColorSchemes.GnBu, value: "15" },
    { key: "Greens", text: "Greens", value2: customColorSchemes.Greens, value: "16" },
    { key: "OrRd", text: "OrRd", value2: customColorSchemes.OrRd, value: "17" },
    { key: "Oranges", text: "Oranges", value2: customColorSchemes.Oranges, value: "18" },
    { key: "PRGn", text: "PRGn", value2: customColorSchemes.PRGn, value: "19" },
    { key: "PiYG", text: "PiYG", value2: customColorSchemes.PiYG, value: "20" },
    { key: "PuBu", text: "PuBu", value2: customColorSchemes.PuBu, value: "21" },
    { key: "PuBuGn", text: "PuBuGn", value2: customColorSchemes.PuBuGn, value: "22" },
    { key: "PuOr", text: "PuOr", value2: customColorSchemes.PuOr, value: "23" },
    { key: "PuRd", text: "PuRd", value2: customColorSchemes.PuRd, value: "24" },
    { key: "RdPu", text: "RdPu", value2: customColorSchemes.RdPu, value: "25" },
    { key: "RdYlBu", text: "RdYlBu", value2: customColorSchemes.RdYlBu, value: "26" },
    { key: "RdYlGn", text: "RdYlGn", value2: customColorSchemes.RdYlGn, value: "27" },
    { key: "Reds", text: "Reds", value2: customColorSchemes.Reds, value: "28" },
    { key: "YlGn", text: "YlGn", value2: customColorSchemes.YlGn, value: "29" },
    { key: "YlGnBu", text: "YlGnBu", value2: customColorSchemes.YlGnBu, value: "30" },
    { key: "YlOrBr", text: "YlOrBr", value2: customColorSchemes.YlOrBr, value: "31" },
    { key: "YlOrRd", text: "YlOrRd", value2: customColorSchemes.YlOrRd, value: "32" }
];
